"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.camelToKebab = void 0;
const camelToKebab = (s) => {
    return s.replace(/([a-z][a-z])([A-Z]|[0-9])/g, "$1-$2").toLowerCase();
};
exports.camelToKebab = camelToKebab;
const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
exports.capitalize = capitalize;
